/**
 * Global EULA — the platform-default end-user license agreement bundled
 * into installers. Backed by AppConfig{ type: 'EULA' } via /settings/eula
 * (admin-only: requireAuth + roleAuthorization(ADMIN), satisfied by the
 * console's admin magic-link JWT). Ported from the admin scope of the
 * publisher dashboard's views/eula — audit 2026-06-09.
 *
 * Enveloped ({ success, data }), so we use `unwrap`; the payload is the
 * raw HTML string.
 */
import { client, unwrap } from './client';

export function getEula(): Promise<string> {
  return unwrap<string>(client.get('/settings/eula'));
}

export function updateEula(eula: string): Promise<string> {
  return unwrap<string>(client.patch('/settings/eula', { eula }));
}
